export default __webpack_public_path__ + "images/93c916e2696ea4065a1204a4eeb47e95-chatSvg.svg";